function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
import _ from 'underscore';
import AuthErrors from '../lib/auth-errors';
import Cocktail from '../lib/cocktail';
import FlowEventsMixin from './mixins/flow-events-mixin';
import FormView from './form';
import ServiceMixin from './mixins/service-mixin';
import Template from 'templates/confirm_signup_code.mustache';
import ResendMixin from './mixins/resend-mixin';
import SessionVerificationPollMixin from './mixins/session-verification-poll-mixin';
import PocketMigrationMixin from './mixins/pocket-migration-mixin';
const CODE_INPUT_SELECTOR = '#otp-code';
const proto = FormView.prototype;

let ConfirmSignupCodeView = /*#__PURE__*/function (_FormView) {
  _inherits(ConfirmSignupCodeView, _FormView);

  var _super = _createSuper(ConfirmSignupCodeView);

  function ConfirmSignupCodeView() {
    var _this;

    _classCallCheck(this, ConfirmSignupCodeView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "template", Template);

    return _this;
  }

  _createClass(ConfirmSignupCodeView, [{
    key: "afterVisible",
    value: function afterVisible() {
      // the view is always rendered, but the confirmation may be
      // prevented by the broker.
      const account = this.getAccount();
      return proto.afterVisible.call(this).then(() => this.broker.persistVerificationData(account)).then(() => {
        // waitForSessionVerification handles bounced emails and will redirect
        // the user to the appropriate screen depending on whether the account
        // is deleted. If the account no longer exists, redirects the user to
        // sign up, if the account exists, then notifies them their account
        // has been blocked.
        this.waitForSessionVerification(this.getAccount(), () => {// don't do anything on verification, that's taken care of in the submit handler.
        });
        return this.invokeBrokerMethod('beforeSignUpConfirmationPoll', account);
      });
    }
  }, {
    key: "getAccount",
    value: function getAccount() {
      return this.model.get('account');
    }
  }, {
    key: "setInitialContext",
    value: function setInitialContext(context) {
      const email = this.getAccount().get('email');
      context.set({
        email,
        escapedEmail: `<span class="email">${_.escape(email)}</span>`
      });
    }
  }, {
    key: "beforeRender",
    value: function beforeRender() {
      // User cannot confirm if they have not initiated a sign up.
      if (!this.getAccount()) {
        this.navigate('signup');
      }
    }
  }, {
    key: "resend",
    value: function resend() {
      const account = this.getAccount();
      return account.verifySessionResendCode();
    }
  }, {
    key: "submit",
    value: function submit() {
      const account = this.getAccount();
      const code = this.getElementValue(CODE_INPUT_SELECTOR);
      const newsletters = account.get('newsletters');
      const options = {
        service: this.relier.get('service') || null,
        scopes: this.relier.get('permissions') || null
      };
      return this.user.verifyAccountSessionCode(account, code, options).then(() => {
        this.logViewEvent('verification.success');
        this.notifier.trigger('verification.success');

        if (newsletters) {
          this.notifier.trigger('flow.event', {
            event: 'newsletter.subscribed'
          });
        }

        return this.invokeBrokerMethod('afterSignUpConfirmationPoll', account);
      }).catch(err => {
        if (AuthErrors.is(err, 'INVALID_EXPIRED_SIGNUP_CODE') || AuthErrors.is(err, 'OTP_CODE_REQUIRED') || AuthErrors.is(err, 'INVALID_OTP_CODE')) {
          return this.showValidationError(this.$(CODE_INPUT_SELECTOR), err);
        } // Throw all other errors, these will be displayed in the .error div and not
        // tooltip.


        throw err;
      });
    }
  }]);

  return ConfirmSignupCodeView;
}(FormView);

Cocktail.mixin(ConfirmSignupCodeView, FlowEventsMixin, ResendMixin(), ServiceMixin, SessionVerificationPollMixin, PocketMigrationMixin);
export default ConfirmSignupCodeView;